import script from "./FeaturedSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedSlider.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedSlider.vue?vue&type=style&index=0&id=1483044d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1483044d"]])

export default __exports__